export default {
	requirements_index: ({ requirements_index }) => {
		return requirements_index;
	},
};
